
import { Tooltip } from "antd"
import { useSelector, useDispatch } from "react-redux"
import { useState, useEffect } from "react"
import replace from "../../assets/images/icon-replace.svg"
import disablereplace from "../../assets/images/Icon-replace-disabled.svg"
import TextField from "./TextField"
import ComboBoxField from "./ComboBoxField"
import { getTranslated } from "../../utils/CommonUtils"
import { setCurrentMergedData } from "../../store/reducers/CommonReducer"
import { setIsReplaceButtonClicked } from "../../store/reducers/UUMReducer"

const UMCReplaceComponent = ({ attributes = [] }) => {

  const dispatch = useDispatch()
  const dict = useSelector((state) => state.common.dict)
  const currentMergedData = useSelector((state) => state.common.currentMergedData)
  const [isOpexactivation, setisOpexactivation] = useState(false)

  // Keep attributes in state so UI re-renders on change
  const [localAttributes, setLocalAttributes] = useState([])


  useEffect(() => {
    setLocalAttributes(attributes)
    dispatch(setIsReplaceButtonClicked(false))
  }, [])

  const renderField = (attr, index) => {
    const isReadOnly = attr?.access === "READONLY"
    if (Array.isArray(attr?.enum)) {
      return <ComboBoxField {...attr} />
    }
    return <TextField {...attr} />
  }

  const handleReplace = (fieldId) => {
    // Deep clone attributes to safely modify
    const updatedAttrs = JSON.parse(JSON.stringify(localAttributes))
    const updatedAttrsUser = JSON.parse(JSON.stringify(currentMergedData[0]?.subdomain[0]?.attribute))

    const parentField = updatedAttrs.find((f) => f.id === fieldId)
    const parentFieldUser = updatedAttrsUser.find((f) => f.id === fieldId)

    if (!parentField) return;
    const subAttrs = parentField.attribute.filter(
      (att) => att?.access !== "INTERNAL"
    )

    if (subAttrs.length === 2) {
      if (subAttrs[0].id === "opexactivationsynchro") {
        setisOpexactivation(true)
        if (subAttrs[0].value === "true" || subAttrs[0].value === "active") {
          subAttrs[1].value = "Business"
          parentFieldUser.value = "Business"
        } else{
          subAttrs[1].value = "None"
          parentFieldUser.value = "None"
        }
      } else {
        subAttrs[1].value = subAttrs[0].value
        parentFieldUser.value = subAttrs[0].value
      }

      // Update parent and state
      parentField.attribute = subAttrs

      setLocalAttributes(updatedAttrs)

      const updatedMergedData = currentMergedData.map(item => ({
        ...item,
        subdomain: item.subdomain.map(sub => ({
          ...sub,
          attribute: sub.attribute.map(attr =>
            attr.id === fieldId ? { ...attr, value: parentFieldUser.value, isModified:true } : attr
          )
        }))
      }));

      dispatch(setCurrentMergedData(updatedMergedData))
      dispatch(setIsReplaceButtonClicked(true))
    }
  }


  const visibleAttributes = localAttributes.filter(
    (attr) => attr?.access !== "INTERNAL"
  )

  return (
    <div className="umc-replace-container">
      {visibleAttributes.map((field) => {
        if (Array.isArray(field?.attribute)) {
          const subAttrs = field.attribute.filter(
            (att) => att?.access !== "INTERNAL"
          )

          if (subAttrs.length === 2) {
            return (
              <div className="umc-replace-row" key={field.id}>
                {/* First attribute */}
                <div
                  className={
                    subAttrs?.mandatory
                      ? "umc-replace-col detail-label mandatory-field"
                      : "umc-replace-col detail-label"
                  }
                >
                  <label
                    className="umc-replace-label"
                    style={{ color: "#734FC6" }}
                  >
                    {getTranslated(dict, subAttrs[0].label) ||
                      getTranslated(dict, subAttrs[0].id)}
                    :
                  </label>
                  {renderField(subAttrs[0], 0)}
                </div>

                {/* Replace icon */}
                <div
                  className="umc-replace-icon"
                  onClick={() => handleReplace(field.id)}
                  style={{ cursor: "pointer" }}
                >
                  {(subAttrs[0].value !== subAttrs[1].value && isOpexactivation != true && subAttrs[0].value != null) ? (
                    <Tooltip title="Replace values">
                      <img
                        src={replace}
                        alt="replace"
                        className="umc-replace-img"
                      />
                    </Tooltip>
                  ) : (
                    <img
                      src={disablereplace}
                      alt="replace"
                      className="umc-replace-img"
                    />
                  )}
                </div>

                {/* Second attribute */}
                <div
                  className={
                    subAttrs?.mandatory
                      ? "umc-replace-col detail-label mandatory-field"
                      : "umc-replace-col detail-label"
                  }
                >
                  <label className="umc-replace-label">
                    {getTranslated(dict, subAttrs[1].label) ||
                      getTranslated(dict, subAttrs[1].id)}
                  </label>
                  {renderField(subAttrs[1], 1)}
                </div>
              </div>
            )
          }

        }

        // Single-level field
        return (
          <div className="umc-replace-row" key={field.id}>
            <div className="umc-replace-col">
              <label className="umc-replace-label">
                {field.label || field.id}:
              </label>
              {renderField(field)}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default UMCReplaceComponent
